import React from "react";
import ProductCardsSkeleton from "./ProductCardsSkeleton";
import OrderCardSkeleton from "./OrderCardSkeleton";

const OrderFormSkeleton: React.FC = () => {
  return (
    <div className="container mx-auto p-4 md:w-2/3 xl:w-1/2">
      {/* Product Display Skeleton */}
      <ProductCardsSkeleton />

      {/* Bump Headline Skeleton */}
      <div className="h-4 bg-gray-200 rounded mt-6 w-1/2"></div>

      {/* Order Bump Skeleton */}
      <OrderCardSkeleton />

      {/* Contact Information Skeleton */}
      <div className="mt-8">
        <span className="h-4 bg-gray-200 rounded w-1/3 mb-4"></span>
        <div className="h-10 bg-gray-200 rounded"></div>
      </div>

      {/* Address Form Skeleton */}
      <div className="mt-8">
        <span className="h-4 bg-gray-200 rounded w-1/3 mb-4"></span>
        <div className="h-10 bg-gray-200 rounded"></div>
      </div>

      {/* Payment Information Skeleton */}
      <div className="mt-8">
        <span className="h-4 bg-gray-200 rounded w-1/3 mb-4"></span>
        <div className="h-10 bg-gray-200 rounded"></div>
      </div>

      {/* Summary Skeleton */}
      <div className="mt-8">
        <span className="h-4 bg-gray-200 rounded w-1/3 mb-4"></span>
        <div className="h-10 bg-gray-200 rounded"></div>
      </div>

      {/* Pay Now Button Skeleton */}
      <div className="h-12 bg-gray-300 rounded-full mt-4"></div>
    </div>
  );
};

export default OrderFormSkeleton;
